module.exports = __webpack_public_path__ + "static/media/screen-primary-01.047a93bb.jpg";